module.exports = __webpack_public_path__ + "static/media/Noah-Bold.412ff65e.woff";